@let authData = authorizedData$ | async;
@let upcoming = authData?.upcomingFlightOrders?.edges;
@let past = authData?.pastFlightOrders?.edges;

<header></header>

<div class="trips d-flex flex-column flex-1 mx-auto p-4 pb-8 pt-md-6 px-md-0 pb-md-10">
  @if (!authData) {
    <ds-skeleton [width]="220" [height]="28" />
    <ds-skeleton class="mt-4" [height]="280" />
  } @else if (authData.verification?.required) {
    <!-- Lists are empty until the email is verified. The account verification modal is the UX. -->
  } @else if (!upcoming?.length && !past?.length) {
    <div
      class="trips-empty d-flex flex-column align-items-center justify-content-center flex-1 py-8"
    >
      <img src="assets/images/no-trips.webp" alt="" width="240" height="149" />
      <h1 class="semi-bold mt-6">No trips yet</h1>
      <p class="trips-empty-copy mt-2" data-id="trips-empty">
        Your upcoming and past trips will appear here once you start planning with us
      </p>
    </div>
  } @else {
    @if (upcoming?.length) {
      <section>
        <h2 class="semi-bold d-md-none">Upcoming trips</h2>
        <h1 class="semi-bold d-none d-md-inline">Upcoming trips</h1>

        <div class="d-flex flex-column g-4 mt-4 mt-md-5">
          @for (order of upcoming; track order.node.portalLink) {
            <a
              class="trips-link link"
              data-id="trip-card"
              [routerLink]="['/', PortalRoutes.Trips, order.node.portalLink]"
            >
              <trips-card [trip]="order.node" [banner]="true" />
            </a>
          }
        </div>
      </section>
    }

    @if (past?.length) {
      <section [class.mt-6]="upcoming?.length" [class.mt-md-8]="upcoming?.length">
        <h2 class="semi-bold d-md-none">Past trips</h2>
        <h1 class="semi-bold d-none d-md-inline">Past trips</h1>

        <div class="d-flex flex-column g-4 mt-4 mt-md-5">
          @for (order of past; track order.node.portalLink) {
            <a
              class="trips-link link"
              data-id="trip-card"
              [routerLink]="['/', PortalRoutes.Trips, order.node.portalLink]"
            >
              <trips-card [trip]="order.node" />
            </a>
          }
        </div>
      </section>
    }
  }
</div>
